import {
  ICampaignOverviewState,
  ICampaignOverviewSubmitData,
} from "../../app/store/campaign/campaignOverview/types";
import { ISubmitDataBuilder } from "../types";
import { getCampaignChannelByChnlId } from "../../utilites/util";
import _ from "lodash";
import { CampaignConstants } from "../../constants/CampaignConstants";
import { ConsentConstants } from "../../constants/ConsentConstants";

export default class SubmitDataBuilder implements ISubmitDataBuilder {

  submitData: ICampaignOverviewSubmitData;
  overviewData: ICampaignOverviewState;

  setOverviewData(overviewData: ICampaignOverviewState) {
    this.overviewData = overviewData;
  }

  setOfferId() {
    this.submitData.offerId = this.overviewData.offerId as number;
  }

  setOptionId() {
    this.submitData.optionId = this.overviewData.optionId as number;
  }

  setChannel() {
    this.submitData.channel = getCampaignChannelByChnlId(this.overviewData.cnlId as number);
  }

  setEsimData() {
    if (this.overviewData.eSim) {
      this.submitData.eSim = 'dSim';
    }
  }

  setResponseParams() {
    this.submitData.responseParams = {
      "TARIFF_PACKAGE": {
        "valid": _.get(this.overviewData, "tp.id")
      }
    };
  }

  setEmail() {
    this.submitData.email = this.overviewData.contactEmail;
  }

  setRadioDelivery() {
    switch (this.overviewData.deliveryOption) {
    case CampaignConstants.deliveryOptions.SOFT_ELECTRO:
      this.submitData.radioDelivery = 1;
      break;
    // same as for electro
    case CampaignConstants.deliveryOptions.SOFT_EANEX:
      this.submitData.radioDelivery = 1;
      break;
    case CampaignConstants.deliveryOptions.STO:
      this.submitData.radioDelivery = 3;
      break;
    case CampaignConstants.deliveryOptions.PIS:
      this.submitData.radioDelivery = 4;
      break;
    }
  }

  setStoreId() {
    this.submitData.storeId = this.overviewData.selectedStoreId as number;
  }

  setAddressData() {
    const addressData = this.overviewData.addressData;
    this.submitData.city = (addressData?.city) ? addressData?.city : "";
    this.submitData.municipality = (addressData?.municipality) ? addressData?.municipality : "";
    this.submitData.neighborhood = (addressData?.neighborhood) ? addressData?.neighborhood : "";
    this.submitData.street = (addressData?.street) ? addressData?.street : "";
    this.submitData.houseNumber = (addressData?.buildingNumber) ? addressData?.buildingNumber.toString() : "";
    this.submitData.houseSubNumber = (addressData?.buildingSubNumber) ? addressData?.buildingSubNumber : "";
  }

  setContractDuration() {
    this.submitData.contractDuration = this.overviewData.contractDuration as any;
  }

  setCustomerAcceptConditions() {
    this.submitData.customerAcceptConditions = 1;
  }

  setConsentData() {
    const givenConsents = this.overviewData.givenConsents;
    const changedConsents = this.overviewData.changedConsents;
    if (!givenConsents.globalConsent && changedConsents.globalConsent !== ConsentConstants.statuses.NO_ANSWER) {
      this.submitData.globalConsent = changedConsents.globalConsent;
    }

    if (!givenConsents.cosmosConsent && changedConsents.cosmosConsent !== ConsentConstants.statuses.NO_ANSWER) {
      this.submitData.cosmosConsent = changedConsents.cosmosConsent;
    }

    if (!givenConsents.socialNetworksOfferingsConsent && changedConsents.socialNetworksOfferingsConsent !== ConsentConstants.statuses.NO_ANSWER) {
      this.submitData.socialNetworksOfferingsConsent = changedConsents.socialNetworksOfferingsConsent;
    }

    if (!givenConsents.socialNetworksMatchingConsent && changedConsents.socialNetworksMatchingConsent !== ConsentConstants.statuses.NO_ANSWER) {
      this.submitData.socialNetworksMatchingConsent = changedConsents.socialNetworksMatchingConsent;
    }
  }

  get(): ICampaignOverviewSubmitData {
    return this.submitData;
  }

  build(overviewData: ICampaignOverviewState, submitAction: string) : ICampaignOverviewSubmitData {
    // Set root structure
    this.setOverviewData(overviewData);
    this.submitData = { channel: "", offerId: 0, optionId: 0, responseParams: {}, lsId: 0 };
    // Set common params
    this.setOfferId();
    this.setOptionId();
    this.setChannel();
    this.setResponseParams();
    // Set other params
    switch (submitAction) {
    case CampaignConstants.submitActions.WEBOS:
      this.setEmail();
      this.setCustomerAcceptConditions();
      this.setConsentData();
      this.setEsimData();
      break;
    case CampaignConstants.submitActions.WEBOS_AGENT:
      this.setEmail();
      break;
    case CampaignConstants.submitActions.ELECTRO:
      this.setRadioDelivery();
      break;
    case CampaignConstants.submitActions.EANEX:
      this.setRadioDelivery();
      break;
    case CampaignConstants.submitActions.STORE:
      this.setEmail();
      this.setRadioDelivery();
      this.setStoreId();
      break;
    case CampaignConstants.submitActions.OTHER_ADDRESS:
      this.setEmail();
      this.setRadioDelivery();
      this.setAddressData();
      break;
    case CampaignConstants.submitActions.P2P:
      this.setEmail();
      this.setContractDuration();
      break;
    }
    return this.get();
  }

}
